import { IAdapter } from './interfaces';

export class ConsoleAdapter implements IAdapter {
  /*tslint:disable:no-console*/
  public log(level: string, message: string, contexts: any) {
    switch (level) {
      case 'error':
      case 'fatal':
      case 'critical':
        console.error(message, contexts);
        break;
      case 'debug':
        console.debug(message, contexts);
        break;
      case 'info':
        console.info(message, contexts);
        break;
      case 'warning':
        console.warn(message, contexts);
        break;
      default:
        console.log(`${level.toUpperCase()}: ${message}\n`, contexts);
    }
  }

  /*tslint:enable:no-console*/
}
